import { createContext } from "react";

const ColorWeekD = createContext();

export default ColorWeekD;